import React from "react";
import { useParams } from "react-router-dom";
import OrderPickingDetail from "./index";
import { CHEFS_FARM, GROWY } from "../../../../constants/CompanyConstants";

const OrderDetailWrapper = () => {
  const { companyType } = useParams();

  const getCompanyConfig = (type) => {
    switch (type) {
      case "chefs-farm":
        return {
          companyFilter: CHEFS_FARM,
          logoSrc: "/img/logo.png",
          logoAlt: "Chef's Farm logo",
        };
      case "growy":
        return {
          companyFilter: GROWY,
          logoSrc: "/img/logo-growy.png",
          logoAlt: "Growy logo",
        };
      default:
        return {
          companyFilter: "All",
          logoSrc: "/img/logo.png",
          logoAlt: "Logo",
        };
    }
  };

  const config = getCompanyConfig(companyType);

  return <OrderPickingDetail {...config} companyFilter={config.companyFilter} />;
};

export default OrderDetailWrapper;
